import React, { useState } from 'react';

import { isEmpty } from 'lodash';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

const ConfigurationTextField = ({
    name,
    configuration,
    setConfiguration,
    formik,
    classes,
    label,
    value,
    ...props
}) => {

    const [text, setText] = useState(value || label);

    const handleText = event => {
        setText(event.target.value);
    };

    const handleBlur = () => {
        formik.setFieldValue(name, text, false);
        // update axis name in configuration
        if (!isEmpty(configuration) && !isEmpty(configuration.sensorGraphConfiguration)) {
            const { sensorGraphConfiguration } = configuration;
            if ( name === 'leftYAxis') {
                sensorGraphConfiguration.axes[0] = text;
            } else if ( name === 'rightYAxis1') {
                sensorGraphConfiguration.axes[1] = text;
            } else if ( name === 'rightYAxis2') {
                sensorGraphConfiguration.axes[2] = text;
            } else if ( name === 'rightYAxis3') {
                sensorGraphConfiguration.axes[3] = text;
            } else if ( name === 'rightYAxis4') {
                sensorGraphConfiguration.axes[4] = text;
            } else if ( name === 'rightYAxis5') {
                sensorGraphConfiguration.axes[5] = text;
            }

            setConfiguration({...configuration, sensorGraphConfiguration});
        }
    };

    return (
        <FormControl className={classes.inputWrapper}>
            <TextField
                id={name}
                name={name}
                type="text"
                value={text}
                onChange={handleText}
                InputLabelProps={{
                    classes: {
                        error:   classes.error,
                        focused: classes.labelFocused,
                        root:    classes.label
                    }
                }}
                InputProps={{
                    onBlur:  handleBlur,
                    classes: {
                        error:     classes.cssErrorUnderline,
                        underline: classes.cssUnderline,
                        root:      classes.input
                    }
                }}
                FormHelperTextProps={{
                    classes: {
                        error: classes.error
                    }
                }}
                error={Boolean(formik.errors.leftYAxis) && Boolean(formik.touched.leftYAxis)}
            />
        </FormControl>
    );
};

export default ConfigurationTextField;
